<template>
    <card shadow type="secondary">
        <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-8">
                    <h3 class="mb-0">Neues Profil hinzufügen</h3>
                </div>
            </div>
        </div>
        <template>
            <form @submit.prevent="create">
                <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                <h6 class="heading-small text-muted mb-4">Angaben zum Profil</h6>
                <profileform ref="PForm"/>
                <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                    <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                    <span class="btn-inner--text">Profil anlegen</span></button>
            </form>
        </template>
    </card>
</template>

<script>
    import Profileform from "@/views/Profiles/Details/profileform";
    export default {
        name:"create",
        components:{Profileform},
        data() {
            return {
                isLoading: false,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        methods: {
            create() {
                this.$store.dispatch('alert/clear');
                    this.isLoading = true;
                    this.createProfile()
                        .then(response => {
                            this.isLoading = false;
                            this.status =  {type: 'success', msg: 'Profil (ID: '+response.id+') wurde erstellt. '};
                            this.$store.dispatch('alert/success',this.status.msg);
                            this.$router.push('/users/profiles');
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.status =  {type: 'danger', msg: error};
                        })
            },
            createProfile() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.$refs.PForm.profile;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/profiles`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);
                            });
                });
            }
        }
    }
</script>

<style scoped>

</style>